import * as constants from './constants'

const locationsInitialState = {
    location: null,
    hasPromoPrice: false,
    invoice: null,
    termsConditions: null,
    purchaseData: {
        startDate: null,
        product: null,
        delivery: null,
        vehicles: null,
    },
}

export const reducer = (state = locationsInitialState, action) => {
    switch (action.type) {
        case constants.GET_SUBSCRIPTION_LOCATION: {
            return locationsInitialState
        }
        case constants.SET_SUBSCRIPTION_LOCATION:
            return {
                ...state,
                location: action.data,
            }
        case constants.SET_LOCATION_RATES:
            return {
                ...state,
                location: {
                    ...state.location,
                    products: action.products,
                    waitListProducts: action.waitListProducts,
                },
                hasPromoPrice: action.hasPromoPrice,
            }
        case constants.SET_ORDER_SUMMARY:
            return {
                ...state,
                invoice: action.data,
            }
        case constants.SET_TERMS_AND_CONDITIONS:
            return {
                ...state,
                termsConditions: action.data,
            }
        case constants.SET_PURCHASE_DATA:
            return {
                ...state,
                purchaseData: action.data,
            }
        case constants.SET_COLLECT_ADDRESS:
            return {
                ...state,
                collectAddress: action.data,
            }
        case constants.SET_SUMMARY_ADDRESS:
            return {
                ...state,
                summaryAddress: action.data,
            }
        default:
            return state
    }
}
